<template>
    <div class="case-presentation">
        <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
            <el-tab-pane :label="item.title" v-for="(item, index) in caseTypeList" :key="index">
                <el-row>
                    <template v-for="(item, caseIndex) in item.caseList">
                        <el-col :xs="12" :sm="12" :md="8" :key="caseIndex">
                            <div class="case-info">
                                <img class="pic" :src="item.pic" alt="">
                                <div class="info">
                                    <span v-text="item.title + ' '"></span>
                                    <el-tag class="tag" size="mini" v-for="(tag, ti) in item.tags" :key="ti">{{ tag }}</el-tag>
                                </div>
                            </div>
                        </el-col>
                    </template>
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        activeName: '0',
        caseTypeList: [{
            title: '电商系统',
            caseList: [{
                pic: '/static/productCase/电商/1.jpg',
                title: '单用户商城小程序',
                tags: ['商城', '秒杀', '单用户']
            }, {
                pic: '/static/productCase/电商/2.jpg',
                title: '多用户商城小程序',
                tags: ['商城', '秒杀', '多用户']
            }, {
                pic: '/static/productCase/电商/3.jpg',
                title: '社区团购小程序',
                tags: ['商城', '秒杀', '社区']
            }]
        }, {
            title: '聊天交友',
            caseList: [{
                pic: '/static/productCase/聊天交友/1.jpg',
                title: '乐享优选商城类APP',
                tags: ['商城', '秒杀', '拼团']
            }, {
                pic: '/static/productCase/聊天交友/2.jpg',
                title: '智慧农场养殖类商城APP',
                tags: ['智慧农场', '农场养殖', '商城']
            }, {
                pic: '/static/productCase/聊天交友/3.jpg',
                title: '智慧农场商城系统',
                tags: ['智慧农场', '商城']
            }]
        }, {
            title: '盲盒抽奖',
            caseList: [{
                pic: '/static/productCase/盲盒/1.jpg',
                title: '盲盒小程序',
                tags: ['盲盒', '秒杀', '小程序']
            }, {
                pic: '/static/productCase/盲盒/2.jpg',
                title: '盲盒小程序',
                tags: ['盲盒', '秒杀', '小程序']
            }, {
                pic: '/static/productCase/盲盒/3.jpg',
                title: '盲盒H5',
                tags: ['盲盒', '秒杀', '抽奖', 'H5']
            }]
        },
        // {
        //     title: '数字藏品',
        //     caseList: [{
        //         pic: '/static/productCase/数字藏品/1.jpg',
        //         title: '乐享优选商城类APP',
        //         tags: ['商城', '秒杀', '拼团']
        //     }, {
        //         pic: '/static/productCase/数字藏品/2.jpg',
        //         title: '智慧农场养殖类商城APP',
        //         tags: ['智慧农场', '农场养殖', '商城']
        //     }, {
        //         pic: '/static/productCase/数字藏品/3.jpg',
        //         title: '智慧农场商城系统',
        //         tags: ['智慧农场', '商城']
        //     }]
        // }
        ]
      };
    },
    methods: {}
  };
</script>

<style lang="less" scoped>
    .case-presentation {
        /deep/.el-tabs {
            .el-tabs__item {
                font-size: 18px;
                line-height: 18px;
            }
            .el-tab-pane {
                .case-info {
                    width: 100%;
                    padding: 20px 50px;
                    box-sizing: border-box;
                    .pic {
                        width: 100%;
                        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
                    }
                    .info {
                        padding: 10px;
                        .tag {
                            margin-left: 5px;
                        }
                    }
                }
            }
        }
    }
</style>